export default "__VITE_ASSET__D3n6qxhq__"